import React from 'react'
import { Switch, Route } from 'react-router-dom'

import enhance from './enhance'
import NotesBreadcrumb from './NotesBreadcrumb'

import TemplatesBreadCrumb from './TemplatesBreadCrumb'
import { Wrapper } from './Layout'

const TopbarNotesBreadcrumb = React.memo(enhance(NotesBreadcrumb))

export default () => (
  <Switch>
    <Route path="/app/templates/:templateId">
      {({ match }) => (
        <TemplatesBreadCrumb templateId={match.params.templateId} />
      )}
    </Route>
    <Route path="/app/*/notes/:noteId">
      {({ match }) => <TopbarNotesBreadcrumb noteId={match.params.noteId} />}
    </Route>
    <Route path="*">
      <Wrapper />
    </Route>
  </Switch>
)
